module.exports = __webpack_public_path__ + "img/badContrast.e282b0f2.svg";